import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { api, globalErrorHandler } from '../../api/create-api';
import { Row, Col, Button, ButtonGroup, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Prompt } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faPlus, faEdit, faList } from '@fortawesome/free-solid-svg-icons';
import { Field } from '@galop/component-library';
import { CancelButton, SelectCollection, SearchableSelect } from '@galop/component-library';

import { GetOptionText, groupBy, NumericizeObjectProperties } from '../../Helpers/Helper';
import { makeCall } from '../../auth-utils';
import Can from '../Shared/Can';
import { DeleteButton } from '@galop/component-library';
import { useFormFields } from '../Shared/FormFields';

export const ViewTopic = (props) => {
    const ls = require('local-storage');
    const { config, IsDirty, resource, userId, Close, Save, NewResource, ReloadResources, types } = props;
    const { addToast, removeToast } = useToasts();

    /* Generic Variables */
    //const [resourceRecord, setResourceRecord] = useState(resource || {});
    const [resourceRecord, updateResource, setResourceRecord] = useFormFields(resource || {}, () => setResourceIsDirty(true));
    const [editResource, setEditResource] = useState(NewResource);
    const [resourceIsDirty, setResourceIsDirty] = useState(false);

    /* Resource Specific Variables */
    const [redirect, setRedirect] = useState('');
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        IsDirty(resourceIsDirty || editing);
    }, [resourceIsDirty, editing]);

    useEffect(() => {
        if (resource) {
            setResourceRecord(resource);
            if (('loaded' in resource) && !resource.loaded) {
                addToast(`Loading ${resource.name} data...`, { appearance: 'info', id: 'loading-data' });
            }
            else {
                removeToast('loading-data');
            }
        }
    }, [resource]);

    const deleteResource = async () => {
        makeCall(async (authHeader) => {
            addToast(`Deleting ${config.capitalResourceName}`, { appearance: 'info', id: 'deleting-resource' });
            await api.delete(`api/${config.controllerName}/${resourceRecord.id}`, {
                headers: authHeader
            }).catch((error) => globalErrorHandler(error, addToast));
            removeToast('deleting-resource', () => {
                setResourceIsDirty(false);
                if (Save) {
                    Save({ ...resourceRecord, deleted: !resource.deleted });
                }

                if (ReloadResources) {
                    ReloadResources();
                }

                Close();
            });
        });
    };

    const goToPage = (resource, to) => {
        if (resource) {
            ls(config.localStorage, resource);
        }
        setRedirect(to);
    };

    const resourceIsValid = () => {
        let isValid = true;
        isValid = isValid && (resourceRecord.name); /* Check for Email */

        return isValid;
    };

    const saveResource = () => {
        if (resourceIsValid()) {
            makeCall(async (authHeader) => {
                addToast(`Saving ${resourceRecord.name}`, { appearance: 'info', id: 'saving-resource' });
                if (resourceRecord.new) {
                    delete resourceRecord.id;
                }
                const result = await api({
                    method: (resourceRecord.new ? 'post' : 'put'),
                    url: `api/${config.controllerName}`,
                    data: NumericizeObjectProperties(resourceRecord),
                    headers: authHeader
                })
                    .catch(error => globalErrorHandler(error, addToast));

                if (result) {
                    setResourceIsDirty(false);
                    if (Save) {
                        if (resourceRecord.new && result.data) {
                            /* Resource was saved */
                            Save(result.data);
                        }
                        else {
                            Save(resourceRecord);
                        }
                    }
                    setEditResource(false);
                }

                removeToast('saving-resource');
            });
        }
        else {
            addToast('A required field is missing.', { appearance: 'error', autoDismiss: true });
        }
    };

    return (
        <div className="mb-2 d-flex flex-column h-100">
            {redirect && <Redirect to={redirect} />}
            <Prompt when={resourceIsDirty} message='You have unsaved changes, are you sure you want to leave?' />
            <div className="mb-1">
                <Row>
                    <Col className="d-flex">
                        <div className="d-inline-block d-md-none">
                            <Button color="link" className="py-0" onClick={Close}><FontAwesomeIcon icon={faChevronLeft} /></Button>
                        </div>
                        <div className="flex-fill d-flex">
                            <span className="h3 text-dark pb-0 mb-0">{resource.name}</span>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="flex-fill scrollable-list border-top border-bottom" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <Row className="my-2 my-sm-0">
                    {editResource && <Col>
                        <Field type="text" label="Name" field="name" value={resourceRecord.name} fieldClassName={!resourceRecord.name ? 'is-invalid' : ''} onChange={updateResource} EnableInput={{ disabled: !editResource }} />
                    </Col>}
                    <Col xs="2">
                        <Field type="text" label="Sort" field="sort" value={resourceRecord.sort} onChange={updateResource} EnableInput={{ disabled: !editResource }} />
                    </Col>
                    {/*<Col>*/}
                    {/*    <Field type="select" label="Type" field="topicTypeId" value={resourceRecord.topicTypeId} fieldClassName={!resourceRecord.topicTypeId ? 'is-invalid' : ''} onChange={updateResource} EnableInput={{ disabled: !editResource }} help={!types || !types.length ? 'Please add a resource before adding a property.' : null}>*/}
                    {/*        <option value="">Select a Type</option>*/}
                    {/*        {types && types.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}*/}
                    {/*    </Field>*/}
                    {/*</Col>*/}
                </Row>
            </div>
            <Row className="pt-1">
                {!NewResource && (!resourceRecord.properties || !resourceRecord.properties.length) && (resourceRecord.deleted ?
                    <Can role={config.writeRole}
                        yes={() => <Col>
                            <DeleteButton color="danger" Close={deleteResource} ShowDropdown={true}>Delete</DeleteButton>
                        </Col>}
                    />
                    : <Can role={config.writeRole}
                        yes={() => <Col>
                            <DeleteButton color="danger" outline Close={deleteResource} ShowDropdown={true}>Delete</DeleteButton>
                        </Col>}
                    />)}
                {!editResource ?
                    <Col className="text-end">
                        <Button color="light" className="border me-1" onClick={Close}>Close</Button>
                        <Can role={config.writeRole}
                            yes={() => <Button color="secondary" onClick={() => setEditResource(true)}>Edit</Button>}
                        />
                    </Col>
                    :
                    <Col className="text-end">
                        <CancelButton color="light" className="border me-1" Close={resource && !resourceIsDirty && !resource.new ? () => {
                            setResourceRecord(resource);
                            setResourceIsDirty(false);
                            setEditResource(false);
                        } : Close} Reload={() => {
                            setResourceRecord(resource);
                            setResourceIsDirty(false);
                        }} ShowDropdown={resourceIsDirty}>Cancel</CancelButton>
                        <Button color="success" disabled={!resourceIsDirty} onClick={() => saveResource()}>Save</Button>
                    </Col>

                }
            </Row>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Topics/ViewTopic.js